<template>
    <div style="align-items: center;">
        <div style="color: #585D66;">
            <span style="font-weight: bold;">
                系统上传要求：
            </span>
            单图分辨率{{ operatePicInfo.DSK_WIDTH }}*{{ operatePicInfo.DSK_HEIGHT }}px，最大不得超过2M｜仅支持JPG、JPEG格式
        </div>
        <ImageUpload
            v-if="mode==='edit' || getImageValue()"
            class="list-picture"
            :max-pic="1"
            :mode="mode==='edit' ? 'single' : 'show'"
            :validate-rule="primeValidateRule"
            :can-delete="true"
            :value="getImageValue()"
            :dg-water-mark="true"
            :white-pic-adjust="true"
            :disabled="isDisabled"
            @addSuccessSingle="handlerImage"
            @modifySuccessSingle="handlerImage"
            @remove="handlerImage"
        />
        <span v-else>无</span>
        <mc-link
            v-if="picRuleUrl"
            :path="picRuleUrl"
        >
            查看审核要求
        </mc-link>
    </div>
</template>

<script>
/* eslint-disable import/no-unresolved */
import {
    computed, getCurrentInstance,
} from '@vue/composition-api';
import { operatePicInfo } from 'utils/enum';
import ImageUpload from 'components/ImageUpload';
import judgeAttrUnderReview from 'utils/spAttrsApprove';
import MixinJudgeRejectedAttrsDisabled from './createNewProduct/mixins/rejectedDisabled';
import { primeValidateRule } from './config';

export default {
    components: {
        ImageUpload,
    },
    mixins: [MixinJudgeRejectedAttrsDisabled],
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        mode: {
            type: String,
            default: '',
        },
        // horn配置
        hornConfig: {
            type: Object,
            default: () => ({}),
        },
        // 图片规则
        picRule: {
            type: Object,
            default: () => ({}),
        },
        // 审核字段
        modifiyAttrs: {
            type: Array,
            default: () => ([]),
        },
        judgeAttrDisabled: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            primeValidateRule,
            operatePicInfo,
        };
    },
    setup(props) {
        const { proxy } = getCurrentInstance();

        // 图片审核要求
        const picRuleUrl = computed(() => props.hornConfig?.primeSelectPicture || '');

        // 是否禁用
        const isDisabled = computed(() => judgeAttrUnderReview(props.modifiyAttrs, 'primeSelectPicture')
            || props.judgeAttrDisabled
            || proxy.MixinJudgeRejectedAttrsDisabled('primeSelectPicture'));

        // value值
        const getImageValue = computed(() => () => (props.value && props.value.picUrl) || '');


        // 列表图操作
        const handlerImage = (imageObj, index) => {
            proxy.$emit('input', imageObj, index);
        };

        return {
            picRuleUrl,
            isDisabled,
            getImageValue,
            handlerImage,
        };
    },
};
</script>

<style lang="scss" scoped>

.img-quality-info {
    font-size: 12px;
    text-align: center;
    width: 130px;
    .img-quality-info-score {
        line-height: 20px;
    }
    .img-quality-info-reason {
        line-height: 20px;
        background: red;
        color: #fff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 5px;
    }
}

.example-list {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.mc-button {
    &.ml-400 {
        margin-left: 380px;
    }

    &.rotate-90,
    &.rotate--90 {
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.3s ease;
    }

    &.rotate-90 {
        transform: rotate(90deg);
    }

    &.rotate--90 {
        transform: rotate(-90deg);
    }

    ::v-deep .mtdicon-fast-backward {
        font-size: 25px;
    }
}

.wrapper {
    border: none;
    ::v-deep {
        .img-area,
        .add-img {
            width: 130px !important;
            height: 130px !important;
            margin: 0 !important;
        }
    }
}

</style>
